export default {
  // Sustantivos / títulos generales del módulo
  item_group: 'Item group',
  forms: 'Forms',
  group_forms: 'Group Forms',
  test_forms: 'Test Forms',
  approver_forms: 'Management Forms',

  // Acciones sobre un formulario (menú de tarjeta — Item.vue, ItemTest.vue, ItemApprover.vue)
  preview: 'Preview',
  edit: 'Edit form',
  edit_config: 'Form setting',
  delete: 'Delete form',
  download_pdf: 'Download PDF',
  send_test_email: 'Send by Email',
  close: 'Close',
  no_results: 'No Results',
  forms_selected: '{n} forms selected',
  select_placeholder: 'Select',

  // Opciones de respuesta Sí/No/NA (FormGroup.vue, FieldYesNo.vue, FormTestYesNo.vue —
  // antes en i18n/items.js, movidas aquí en la Fase 5 por ser 100% del módulo Formularios)
  form_yes_no: {
    yes: 'Yes',
    no: 'No',
    na: 'NA'
  },

  form_checkitem: {
    unanswered: 'Unanswered',
    na: 'N/A'
  },

  form_table: {
    add_row: 'Add row',
    totals: 'Totals',
    simulate_import_totals: 'Simulate import totals',
    import_totals: 'Import Totals'
  },

  form_reading: {
    last_reading_offline: 'No connection: the previous reading could not be retrieved. You can enter it; ' +
      'once the connection is back, if there is a previous audit, it will be replaced by its reading.'
  },

  form_catalog: {
    search_hint: 'Type at least 3 characters to search'
  },

  comments: {
    label: 'Additional comments'
  },

  // Historial de aprobación (ApprovalHistoryDialog.vue)
  approval_history: {
    title: 'Approval History',
    loading: 'Loading history...',
    empty: 'No activity recorded for this form yet.',
    error: 'Could not load approval history.',
    retry: 'Retry',
    close: 'Close',
    no_comments: 'No comments',
    unknown_actor: 'Unknown user',
    entry_type_test: 'Test',
    entry_type_comment: 'Comment',
    status_testing: 'Testing',
    status_completed: 'Test completed',
    status_pending_approval: 'Pending approval',
    status_approved: 'Approved',
    status_rejected: 'Rejected',
    status_changes_requested: 'Changes requested',
    status_commented: 'Commented',
    status_published: 'Published',
    status_untested: 'Untested'
  },

  // Resultados de prueba (TestResultsDialog.vue)
  test_results: {
    title: 'Test Results',
    loading: 'Loading results...',
    empty: 'This form has no recorded tests yet.',
    error: 'Could not load test results.',
    retry: 'Retry',
    close: 'Close',
    unknown_tester: 'Unknown tester',
    status_testing: 'In progress',
    status_completed: 'Completed',
    status_rejected: 'Rejected',
    status_approved: 'Approved',
    status_commented: 'With remarks',
    status_published: 'Published',
    status_unknown: 'No status'
  },

  // Complementos de un ítem (OccurrenceItemAddonDialog.vue, OccurrenceTaskAddSection.vue, stores/occurrences/actions.js)
  addons: {
    add_comment: 'Add comment',
    add_picture: 'Add picture',
    add_task: 'Add task',
    add_document: 'Add document',
    add_video: 'Add video',
    video_too_large: 'Video exceeds the maximum allowed size (45 MB).',
    video_rejected_by_server: 'The server rejected the video by size or format. It stays on the device, but cannot be uploaded as is.',
    video_upload_retry: 'The video could not be uploaded. It stays on the device and will be retried.'
  },

  // Estado del proceso de testing/aprobación (TestingProcessModal.vue)
  testing_process: {
    title: 'Process Status',
    process_info_title: 'Process Information',
    sent_to_test_label: 'Sent to Test:',
    process_status_label: 'Process Status:',
    rejection_reason_title: 'Rejection Reason',
    rejection_reason_default: 'The form requires corrections.',
    comments_history_title: 'Comment History',
    loading_history: 'Loading history...',
    no_comments: 'No comments recorded',
    resend_to_test: 'Resend to Test',
    send_to_test: 'Send to Test',
    edit_before_resend_tooltip: 'You must edit the form before resending it',
    go_to_editor: 'Go to Editor',
    status_draft_label: 'Draft',
    status_draft_description: 'The form is ready to be sent to testing.',
    status_testing_label: 'In Testing',
    status_testing_description: 'The form is being evaluated by testers.',
    status_tested_label: 'Tested',
    status_tested_description: 'The form was tested successfully. Awaiting approval.',
    status_approved_label: 'Approved',
    status_approved_description: 'The form was approved and is ready for publication.',
    status_rejected_label: 'Changes Required',
    status_rejected_description: 'The form was rejected and requires corrections before continuing.',
    status_published_description: 'The form is published and available for use.',
    badge_commented: 'Comment',
    badge_rejected: 'Rejected',
    badge_sent: 'Sent',
    badge_testing: 'Testing',
    unknown_user_fallback: 'User'
  },

  // Tarjeta de formulario en la lista de gestión (Item.vue)
  item: {
    tooltip_rejected: 'Changes requested - Requires corrections from the creator',
    tooltip_published: 'Form published and available for use',
    tooltip_approved: 'Form approved - Ready to publish',
    menu_view_process: 'View Process Status',
    menu_return_to_draft: 'Return to Draft',
    dialog_return_message: 'Return the form "{name}" to draft? You will be able to edit it and resend it for testing.',
    loading_return: 'Returning to draft...',
    notify_return_success: 'Form returned to draft',
    notify_return_error: 'Error returning form to draft',
    retry_caption: 'Please try again',
    bottom_sheet_title: 'Form: {name}',
    dialog_send_title: 'Send to Test',
    dialog_send_message: 'Are you sure you want to send this form to the testers for review?',
    dialog_send_ok: 'Send',
    loading_send: 'Sending form for testing...',
    notify_send_success: 'Form sent for testing successfully',
    notify_send_error_fallback: 'Error sending form',
    notify_delete_success: 'Form deleted successfully',
    notify_delete_error: 'Error deleting the form',
    notify_check_dependencies_error: 'Error checking dependencies',
    delete_dependencies_message_singular: `The form "{name}" has {count} associated routine activity record that will be deleted.
      <br><br>Do you want to continue?`,
    delete_dependencies_message_plural: `The form "{name}" has {count} associated routine activity records that will be deleted.
      <br><br>Do you want to continue?`,
    tooltip_status_draft: 'Form ready to send for testing',
    tooltip_status_sent: 'Form sent for testing - Awaiting assignment',
    tooltip_status_testing: 'Form currently being tested',
    tooltip_status_tested: 'Form tested - Awaiting approval',
    tooltip_status_approved: 'Form approved - Ready to publish',
    tooltip_status_rejected: 'Form rejected - Requires corrections',
    tooltip_status_published: 'Form published and available'
  },

  // Tarjeta de formulario en la lista de testing (ItemTest.vue)
  item_test: {
    tooltip_already_approved: 'This form has already been approved and requires no further action',
    tooltip_rejected: 'This form was rejected and requires corrections',
    badge_approved: '✓ Approved',
    badge_rejected: '✗ Rejected',
    tooltip_has_comments: 'Has test comments',
    tooltip_sent_by: 'Sent by: {name}',
    tooltip_assigned_to: 'Assigned to: {name}',
    tooltip_sent_date: 'Sent on: {date}',
    btn_comment: 'Comment',
    btn_test: 'Test',
    btn_continue_test: 'Continue Test',
    btn_finish_test: 'Finish Test',
    btn_approve: 'Send for Approval',
    btn_reject: 'Reject form',
    chip_processed: 'Form processed - No further action required',
    rejection_reason_prefix: 'Reason: {reason}',
    menu_view_history: 'View Test History',
    status_untested_label: 'Untested',
    status_testing_label: 'Testing',
    status_tested_label: 'Tested',
    status_commented_label: 'With Comments',
    status_approved_label: 'Approved',
    status_rejected_label: 'Rejected',
    status_unknown_label: 'Unknown',
    tooltip_status_untested: 'This form has not been tested yet',
    tooltip_status_testing: 'Currently being tested',
    tooltip_status_tested: 'Form tested, awaiting approval',
    tooltip_status_commented: 'Form tested with pending comments',
    tooltip_status_approved: 'Form approved, ready to publish',
    tooltip_status_rejected: 'Form rejected, requires corrections',
    tooltip_status_published: 'Form published and available',
    loading_updating_list: 'Updating list...',
    dialog_start_test_title: 'Start Test',
    dialog_start_test_message: `Do you want to start testing the form "{name}"? You will be redirected to test mode
      where you can fill out the form.`,
    dialog_start_test_ok: 'Start',
    notify_start_test_success: 'Redirecting to test mode...',
    notify_start_test_success_caption: 'You will be able to fill out and fully test the form',
    notify_start_test_error_fallback: 'Error starting the test',
    dialog_continue_test_title: 'Continue Test',
    dialog_continue_test_message: `Do you want to continue testing the form "{name}"? You will be redirected to test mode
      where you can continue filling out the form.`,
    dialog_continue_test_ok: 'Continue',
    notify_continue_test_success: 'Continuing the test...',
    notify_continue_test_success_caption: 'You can continue filling out the form where you left off',
    dialog_finish_test_message: 'Do you want to finish testing the form "{name}"? This will send the form for approval.',
    dialog_finish_test_ok: 'Finish',
    notify_finish_test_success: 'Test finished. Form sent for approval.',
    notify_finish_test_error: 'Error finishing the test',
    dialog_add_comment_title: 'Add Comment',
    dialog_add_comment_message: 'Enter your comment:',
    loading_saving_comment: 'Saving comment...',
    notify_comment_added: 'Comment added successfully',
    notify_comment_error: 'Error adding the comment',
    dialog_view_history_title: 'Test History',
    dialog_view_history_message: 'History for form "{name}"\n\nTests completed: {count}',
    notify_history_error: 'Error loading test history',
    notify_delete_success: 'Form deleted',
    notify_delete_error: 'Error deleting form',
    dialog_approve_message: `Do you want to send the form "{name}" for approval? This will mark the form as approved and ready
      for publication.`,
    loading_approving: 'Sending for approval...',
    notify_approve_success: 'Form sent for approval successfully',
    notify_approve_success_caption: 'The form has been marked as approved',
    notify_approve_error: 'Error sending for approval',
    dialog_reject_title: 'Reject Form',
    dialog_reject_message: 'Enter the reason for rejection (minimum 10 characters):',
    dialog_reject_placeholder: 'Describe why the form is being rejected...',
    dialog_reject_ok: 'Reject',
    loading_rejecting: 'Rejecting form...',
    notify_reject_success: 'Form rejected',
    notify_reject_success_caption: 'The form has been marked as rejected',
    notify_reject_error: 'Error rejecting the form',
    dialog_publish_title: 'Publish Form',
    dialog_publish_message: 'Do you want to publish the form "{name}"? Once published it will be available for use.',
    dialog_publish_ok: 'Publish',
    loading_publishing: 'Publishing form...',
    notify_publish_success: 'Form published successfully',
    notify_publish_success_caption: 'The form is now available for use',
    notify_publish_error: 'Error publishing the form',
    dialog_return_draft_message: 'Do you want to return the form "{name}" to draft status? This will allow you to edit it again.',
    notify_return_success_caption: 'You can now edit it and fix the identified issues',
    current_user_placeholder: 'Current User'
  },

  // Modo de prueba del formulario (FormTest.vue)
  form_test: {
    error_loading_test: 'Error: Could not load the test information',
    error_form_unavailable: 'Error: Form information not available',
    test_occurrence_id_label: 'Test Occurrence ID: {id}',
    test_mode_label: 'Test Mode:',
    loading_generic: 'Loading...',
    test_mode_warning: 'The entered data will not be saved in the main system.',
    comments_section_title: 'Test Comments',
    comments_placeholder: 'Enter your comments about the form test here...',
    comments_label: 'Test remarks',
    dialog_send_email_title: 'Send test form by email',
    email_list_label: 'Enter one or more emails',
    send_pdf_notice: 'A PDF of the form in test mode will be sent',
    error_form_id_missing: 'Form ID not found in the route',
    error_init_test: 'Error initializing the form test',
    error_unauthorized: 'Unauthorized - Check your session',
    error_forbidden: 'No permissions - You need the form-tester role',
    error_endpoint_not_found: 'Endpoint not found - Check the API configuration',
    error_server_prefix: 'Server error: {message}',
    dialog_cancel_test_title: 'Cancel Test',
    dialog_cancel_test_message: 'Are you sure you want to cancel the test? All entered data will be lost.',
    dialog_cancel_test_ok: 'Yes, cancel',
    dialog_continue_testing: 'Continue testing',
    dialog_finish_test_message: 'Do you want to finish testing this form? A report with your comments will be generated.',
    loading_saving_test: 'Saving test data...',
    notify_complete_success: 'Test completed successfully',
    notify_complete_success_caption: 'The data has been sent to the testing database',
    notify_complete_error: 'Error completing the test',
    validation_missing_answer: 'Missing answer for item: {name}',
    validation_missing_picture: 'Missing picture for: {name}',
    validation_missing_comment: 'Missing comment for: {name}',
    dialog_validation_title: 'Cannot finish the test',
    dialog_validation_footer: 'Meet the form requirements and try again.',
    notify_pdf_unavailable: 'No test data available to generate the PDF',
    loading_generating_pdf: 'Generating test PDF...',
    default_test_location: 'Test Location',
    notify_pdf_success: 'Test PDF generated successfully',
    notify_pdf_error: 'Error generating the test PDF',
    notify_mail_unavailable: 'No test data available to send',
    notify_mail_success: 'Test form sent by email',
    notify_mail_error: 'Could not send the test form',
    default_tester_name: 'Test User',
    error_empty_server_response: 'The server response is empty',
    error_invalid_occurrence_response: 'The server response is not a valid occurrence',
    default_group_name: 'No group',
    // Test header (FormTestHeader)
    default_form_name: 'Test Form',
    test_mode_form_id_label: 'TEST MODE - Form ID:',
    test_location_line: "Location: '{location}'",
    test_score_label: 'TEST SCORE',
    below_standard: 'Below Standard',
    test_mode_active: 'Test Mode Active - Data will not be saved',
    test_in_progress: 'Test in progress',
    // Simulated signatures (FormTestSignaturesSection)
    signatures_simulation_title: 'Signature Simulation (Test Mode)',
    signed: 'Signed ✓',
    click_to_sign: 'Click to simulate signature',
    auditor_name_placeholder: 'Auditor Name (Test)',
    audited_name_placeholder: 'Auditee Name',
    signatures_notice: 'Signatures are simulated in test mode. They will not be stored in the system.',
    signatures_all_completed: 'All signatures completed',
    signatures_partial: 'Partial signatures',
    signatures_none: 'No signatures',
    // Test group (FormTestGroupSection)
    default_test_group_name: 'Test Group',
    // Question add-ons (FormTestItemAddonDialog, FormTestItemAddonsSection)
    add_comment_test: 'Add comment (Test)',
    add_picture_test: 'Add image (Test)',
    upload_picture_test: 'Upload image (Test)',
    comment_test_label: 'Comment (Test Mode)',
    // Unsupported question type (FormTestItemField)
    unsupported_type_title: 'Type not supported for testing',
    unsupported_type_message: 'The type {type} is not currently implemented for test mode.',
    info_button: 'Info',
    simulated_input_label: '{name} (Simulated input)',
    simulated_input_hint: 'This is a generic input to continue the test',
    compatibility_info_title: 'Compatibility Information',
    compatibility_current_type: 'Current type:',
    compatibility_status: 'Status:',
    compatibility_not_supported: 'Not supported for testing',
    compatibility_supported_types: 'Supported types:',
    compatibility_contact_dev: 'To implement this type, contact the development team.',
    // Question list (FormTestItemList)
    test_chip: 'TEST',
    // Options (FormTestCheckbox, FormTestOption)
    option_alt: 'Option',
    no_options_configured: 'There are no options configured for this item in the form.',
    // Table (FormTestTable)
    simulate_import_totals: 'Simulate Import Totals',
    // Photo with simulated AI (FormTestUploadEditPicture)
    test_mode_picture_label: 'Test Mode',
    select_image_hint: 'Select an image to test the feature',
    analyzing_image_simulated: 'Analyzing image (simulated)',
    test_evidence_alt: 'Test evidence',
    select_color: 'Select color',
    ai_approved_simulated: 'Image approved - Meets the evaluation criteria (simulated)',
    ai_rejected_simulated: 'Image rejected - Does not meet the expected criteria (simulated)',
    simulate_ai: 'Simulate AI',
    test_image_title: 'Test Image',
    full_size_preview_alt: 'Full size preview',
    notify_edit_simulated: 'Edit feature simulated in test mode',
    notify_edit_simulated_caption: 'In production, the image editor would open',
    notify_no_ai_reference: 'This question has no reference image for AI',
    notify_ai_simulated: 'Simulated AI analysis completed',
    notify_ai_simulated_caption: 'In production, it would connect to Ozaru Service'
  },

  // Formulario de creación/edición (Form.vue, admin)
  create: {
    standard: 'Company standard',
    field_label: 'Field label',
    name: 'Form name',
    alias: 'Form alias',
    form_save_confirm: 'The changes you are about to save will result in the loss of the current information.',
    form_save_confirm_second: `Making changes to a published form will delete incidents* and this action CANNOT BE UNDONE,
      are you sure you want to apply the changes?<br>*If the Auditor role is changed, all incidents will be deleted.`,
    no_attachments: 'No attachments',
    no_comments: 'No comments',
    images: 'Images',
    comment: 'Comments',
    text_close_action_plan_confirm: 'To save the form you need to close the following action plan: {name}, do you want to close it?',
    published: 'Published',
    action_plan_pending: 'Pending action plan',
    notify_to: 'With additional email notifications to:',
    notify_push_to: 'With additional push notifications to:',
    at: 'at',
    the: 'on',
    by: 'By: ',
    close_at_ending_month: 'Close at end of month',
    close_at_ending_periodicity: 'Based on the start date',
    restrict_by_area_help: 'The assigned role can only fill out the form while physically at the location',
    restrict_by_area: 'Enable geolocation',
    loading: 'Loading',
    email_not_valid: 'is not a valid email',
    search_checklist: 'Search for a form',
    search_franchise: 'Search {franchise}',
    filter_locations: 'Filter Locations',
    search_role: 'Search for a role',
    search_user: 'Search for a user',
    every_two_weeks: 'Every two weeks',
    will_open_soon: 'This form will open soon',
    edit_checklist: 'Edit form',
    form_settings: 'Form settings',
    delete_form: 'Delete form',
    locations: 'Locations',
    missed: 'Non-compliance',
    below_standard: 'Below standard',
    unpublished: 'Unpublished',
    activation: 'Activation',
    activation_help: 'This is the day from which occurrences will be generated for this form',
    periodicity: 'Periodicity',
    assigned_to_roles: 'Form assignment',
    assigned_to_roles_help: 'Select the auditor, the auditee, and the supervisor',
    periodicity_help: 'This is how often your form occurs — daily, monthly, etc.',
    duration: 'Duration',
    duration_help: 'This is how long the form will stay open',
    signatures: 'Signatures',
    notifications_email: 'Email notifications',
    notifications_push: 'Push notifications',
    notificate_to_user: 'Notify the user',
    remind_to_user: 'Remind the user',
    incomplete: 'Non-compliance',
    name_help: 'Enter a name for the form',
    create: 'Create new',
    empty_list: 'Location has no assigned forms',
    empty_list_action_plan: 'No action plans assigned',
    select_from_list: 'Select a location to see its assigned forms',
    select_from_list_action_plan: 'Select a location to see its assigned action plans',
    checklist: 'Form',
    end_date: 'Closing date',
    form_start_hours: 'Opens at',
    start_date: 'Start date',
    start_time: 'Will start from:',
    by_time: 'Time unit',
    special: 'Special',
    end_time: 'Until',
    end_time_new: 'And will stay open for:',
    repeat_days: 'Will repeat: ',
    repeat_every: 'Repeat every',
    hours: 'Hours',
    days: 'Days',
    weeks: 'Weeks',
    months: 'Months',
    years: 'Years',
    choose_a_day: 'Choose a day',
    choose_a_month: 'Choose a month',
    every_one_week: 'Every week on {weekdays}',
    every_n_weeks: 'Every {n} weeks on {weekdays}',
    every_day: 'Daily',
    every_n_days: 'Every {n} days',
    bussiness_days: 'Business days (Monday to Friday)',
    mwf: 'Monday, Wednesday and Friday',
    tth: 'Tuesday and Thursday',
    every_one_month: 'Every month',
    every_n_months: 'Every {n} months',
    every_year: 'Every year',
    every_n_years: 'Every {n} years',
    by_event: 'By event since {date}',
    by_calendar: 'By calendar',
    from_start_date: 'from',
    to_end_date: 'to',
    push: 'Send "Push Notification"',
    email: 'Send Email',
    delete_confirmation: 'Do you want to delete the form "{name}"?',
    multiple_delete_confirmation: 'Do you want to delete the selected action plans?',
    roles_assignment: 'Auditor',
    delete_signature_confirmation: 'Do you want to delete the signature?',
    yes: 'Yes',
    no: 'No',
    supervision: 'Assign supervisor role',
    audited: 'Auditee',
    supervisor_role: 'Supervisor',
    audited_help: 'Person who will be audited',
    supervisor_role_help: 'Person who will follow up on the form',
    franchise: 'Business unit',
    franchise_help: '{franchise} the form belongs to',
    status: 'Form status',
    open: 'Open',
    close: 'Closed',
    to_open: 'About to open',
    all: 'All',
    consolided_value: 'Consolidated value',
    fill_help: 'Person who will fill out the form',
    doesnt_apply: 'Not applicable',
    reset_incidence: 'Updating the location will delete all answers. Continue?',
    responsability_label: 'Label 1',
    leadership_label: 'Label 2',
    signature_settings: 'Signature settings',
    notifications_settings: 'Notification settings',
    notify_review_complete: 'Email notifications when the review is completed',
    notify_below_standard: 'Email notifications below standard',
    notify_review_complete_by_role: 'Email notifications when the review is completed, by role',
    notify_push_below_standard: 'Push notifications below standard',
    responsability_label_tooltip: 'Responsibility label',
    leadership_label_tooltip: 'Leadership label',
    validation_name_suggest_alias: 'We recommend adding an alias',
    validation_alias_max_length: 'The alias cannot be longer than 25 characters',
    signature_customize_additional_label: 'Customize additional signatures',
    additional_signatures_label: 'Additional signatures',
    pdf_customization_title: 'PDF Customization',
    pdf_replace_logo_label: 'Replace logo in PDF',
    pdf_replace_company_label: 'Replace company in PDF',
    pdf_company_label: 'Company',
    extras_title: 'Extras',
    auto_action_plan_label: 'Automatic action plans',
    action_plan_role_label: 'Role',
    priority_label: 'Priority',
    priority_high: 'High',
    priority_medium: 'Medium',
    priority_low: 'Low',
    validity_days_label: 'Validity',
    informative_character_label: 'Informative Character in Integral Audit',
    hide_pending_tasks_label: 'Hide pending tasks',
    hide_pending_tasks_tooltip: 'When enabled, the pending tasks section will not be included in the generated report.',
    publish_label: 'Publish',
    allow_gallery_photos_label: 'Allow Photos from Gallery',
    hide_score_label: 'Hide Score',
    routines_check_label: 'Routines',
    routines_check_tooltip: `This form can only be assigned from a routine and can be answered until the established date
      and time. (It will not be visible from the module used to fill out forms)`,
    editor_role_label: 'Editor/Authorizer User Role:',
    authorized_users_label: 'Authorizing Users (maximum 3):',
    ai_sensitivity_label: 'AI image evaluation sensitivity:',
    clone_label: 'Clone',
    validation_roles_removed_warning: 'Careful! Roles must not be removed from the form. Please contact your administrator.'
  },

  // Selector de ubicaciones de formularios asignados (AssignedList.vue)
  assigned_list: {
    no_locations_match: 'No locations found matching those search criteria.',
    no_locations_nearby: 'No locations available for your current coordinates.',
    no_locations: 'No locations available.'
  },

  // Catálogo de tipos de ítem — constructor de formularios (ElementProps.vue)
  build: {
    label: 'Label',
    'form-checkbox': 'Multiple Checkbox',
    'form-checkitem': 'Checkbox',
    'form-option': 'Multiple Choice',
    'form-select': 'Select from a list',
    'form-yes-no': 'Yes/No/NA',
    'form-catalog': 'Select from a catalog',
    'form-input-text': 'Text',
    'form-textarea': 'Textarea',
    'form-input-email': 'Email',
    'form-input-number': 'Number',
    'form-multinumeric': 'Multinumeric',
    'form-upload-file': 'Upload a file',
    'upload-edit-picture': 'Take a picture',
    'form-location': 'Save current location',
    'form-date': 'Date',
    'form-hour': 'Hour',
    'form-table': 'Table',
    'form-reading': 'Reading',
    'extra-properties-totals': 'Total extra fields',
    'clone-item': 'Clone item'
  }
}
